// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__BdYha","rightAdornment":"Header_rightAdornment__3FWEU"};